import axiosInstanceApiKong from 'config/apiServiceApiGateway'
import {
  generateExternalType,
  gengerateVendorPathExtension,
  gengerateVendorAPIVersion,
} from 'features/Account/utils/generateVendorHeader'

type GetUserListRequestType =
  | Partial<{
      page_index: string | number
      page_size: string | number
      name: string
    }>
  | undefined

export type GetUserListResponseType = {
  users: {
    email: string
    full_name: string
    position: string
    id: number
    phone_number: string
    roles: {
      id: number
      name: string
      tier?: string
    }[]
    active: boolean
    vendor_id?: number
  }[]
}

export type GetUserDetailResponseType = {
  email: string
  full_name: string
  position: string
  id: number
  phone_number: string
  roles: {
    id: number
    name: string
    tier?: string
    location_ids: number[]
  }[]
  active: boolean
}

export type PostUserRequestType = {
  email: string
  is_super_admin: boolean
  locations: {
    is_deleted?: boolean
    id: number
  }[]
  name: string
  phone_number: string
  position: string
  roles: {
    id: number
    is_deleted?: boolean
  }[]
}

export type PostUserResponseType = {
  data: {
    id: number
  }
  error: {
    status: boolean
    message: string
    code: number
  }
}

export type PutUserRequestType = {
  id: number
  payload: PostUserRequestType
  isVendor?: boolean
}

export type PutResetAccountRequestType = {
  phone_number: string
}

export type PutResetAccountResponseType = {
  data: {
    is_success: boolean
  }
  error: {
    status: boolean
    message: string
    code: number
  }
}

export type PatchActivateAccountResponseType = {
  data: {
    is_success: boolean
  }
  error: {
    status: boolean
    message: string
    code: number
  }
}

export const getUserListAPI = (params: GetUserListRequestType, isVendor = false) =>
  axiosInstanceApiKong.Get<GetUserListResponseType>({
    url: `/accounts/internal/${gengerateVendorAPIVersion(
      isVendor,
      'v2',
    )}/user${gengerateVendorPathExtension(isVendor)}`,
    params,
    config: { headers: { ...generateExternalType(isVendor ? 'vendor' : '') } },
  })

export const getUserDetailAPI = (id: number, isVendor = false) =>
  axiosInstanceApiKong.Get<GetUserDetailResponseType>({
    url: `/accounts/internal/${gengerateVendorAPIVersion(
      isVendor,
      'v2',
    )}/user${gengerateVendorPathExtension(isVendor)}/${id}`,
  })

export const postUserAPI = (payload: PostUserRequestType, isVendor = false) =>
  axiosInstanceApiKong.Post<PostUserResponseType>({
    url: `/accounts/internal/${gengerateVendorAPIVersion(
      isVendor,
      'v2',
    )}/user${gengerateVendorPathExtension(isVendor)}`,
    data: payload,
    config: { headers: { ...generateExternalType(isVendor ? 'vendor' : '') } },
  })

export const putUserAPI = ({ id, payload, isVendor = false }: PutUserRequestType) =>
  axiosInstanceApiKong.Put<PostUserResponseType>({
    url: `/accounts/internal/${gengerateVendorAPIVersion(
      isVendor,
      'v2',
    )}/user${gengerateVendorPathExtension(isVendor)}/${id}`,
    data: payload,
    config: { headers: { ...generateExternalType(isVendor ? 'vendor' : '') } },
  })

export const putResetAccountAPI = (payload: PutResetAccountRequestType, isVendor = false) =>
  axiosInstanceApiKong.Put<PutResetAccountResponseType>({
    url: `/accounts/internal/v1/user/totp/reset${gengerateVendorPathExtension(isVendor)}`,
    data: payload,
    config: { headers: { ...generateExternalType(isVendor ? 'vendor' : '') } },
  })

export const patchActivateAccountAPI = (userId: number, isVendor = false) =>
  axiosInstanceApiKong.Patch<PatchActivateAccountResponseType>({
    url: `/accounts/internal/v1/user/activate/${userId}`,
    config: { headers: { ...generateExternalType(isVendor ? 'vendor' : '') } },
  })

export const patchDeactivateAccountAPI = (userId: number, isVendor = false) =>
  axiosInstanceApiKong.Patch<PatchActivateAccountResponseType>({
    url: `/accounts/internal/v1/user/deactivate/${userId}`,
    config: { headers: { ...generateExternalType(isVendor ? 'vendor' : '') } },
  })

export const getRolesAPI = (params: GetUserListRequestType, isVendor = false) =>
  axiosInstanceApiKong.Get<{
    roles: {
      id: number
      name: string
    }[]
  }>({
    url: `/auth/internal/v1/role${gengerateVendorPathExtension(isVendor)}`,
    params,
    config: { headers: { ...generateExternalType(isVendor ? 'vendor' : '') } },
  })
